/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { deploymentsLogs } from "../funcs/deploymentsLogs.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { GetDeploymentLogsResult } from "../models/components/getdeploymentlogsresult.js";
import {
  GetDeploymentLogsRequest,
  GetDeploymentLogsSecurity,
} from "../models/operations/getdeploymentlogs.js";
import { unwrapAsync } from "../types/fp.js";
export type DeploymentLogsQueryData = GetDeploymentLogsResult;

export function prefetchDeploymentLogs(
  queryClient: QueryClient,
  client$: GramCore,
  request: GetDeploymentLogsRequest,
  security?: GetDeploymentLogsSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildDeploymentLogsQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildDeploymentLogsQuery(
  client$: GramCore,
  request: GetDeploymentLogsRequest,
  security?: GetDeploymentLogsSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (context: QueryFunctionContext) => Promise<DeploymentLogsQueryData>;
} {
  return {
    queryKey: queryKeyDeploymentLogs({
      deploymentId: request.deploymentId,
      cursor: request.cursor,
      gramKey: request.gramKey,
      gramSession: request.gramSession,
      gramProject: request.gramProject,
    }),
    queryFn: async function deploymentLogsQueryFn(
      ctx,
    ): Promise<DeploymentLogsQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(deploymentsLogs(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyDeploymentLogs(
  parameters: {
    deploymentId: string;
    cursor?: string | undefined;
    gramKey?: string | undefined;
    gramSession?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "deployments", "logs", parameters];
}
